import { OperatorModel } from '@app/src/views/CipReport/filter/models/Operator';
import { OperatorService } from '@app/src/views/CipReport/filter/models/OperatorService';

export const hydrateOperator = (data: OperatorService): OperatorModel => {

  let operator = data.data.map((operator) => {
    return {
      value: operator.userId.toString(),
      label: operator.fullName
    };
  });

  const dataHydrate: OperatorModel = {
    code: data.code,
    message: data.message,
    operator: operator
  };

  return dataHydrate;
};
